import { Component, Input } from '@angular/core';
import { PageFeature } from '@ervo/page-framework';

@Component({
    selector: 'feature-restrictions-indicators',
    templateUrl: './feature-restrictions-indicators.component.html',
    styleUrls: ['./feature-restrictions-indicators.component.scss'],
    host: {
        class: 'font-small'
    },
    standalone: false
})
export class FeatureRestrictionsIndicatorsComponent {
  @Input() feature: PageFeature;
}
